// Stripe-Atlas-style content shell. Pages extend it and provide
// `eyebrow`, `title`, `sections`, and a `PageBody` child.
//
// v3 has no `props` bag — fields are flattened on the element itself,
// so children read them via `el.parent.parent.eyebrow`.
export const ContentPage = {
  extends: 'Page',
  flow: 'x',
  align: 'flex-start',
  gap: 'D',
  padding: 'D C',
  maxWidth: 'none',
  margin: '0 auto',
  width: '100%',

  PageRail: {
    flow: 'y',
    gap: 'C',
    width: 'G',
    minWidth: 'G',
    flex: '0 0 auto',
    position: 'sticky',
    top: 'D',

    PageHeading: {
      flow: 'y',
      gap: 'A',
      Eyebrow: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: 'blue',
        text: (el, s) => el.parent.parent.parent.eyebrow || ''
      },
      PageTitle: {
        tag: 'h1',
        fontSize: 'D',
        fontWeight: '800',
        color: 'title',
        letterSpacing: '-0.03em',
        lineHeight: '1.1',
        margin: '0',
        text: (el, s) => el.parent.parent.parent.title || ''
      }
    },

    SectionList: {
      flow: 'y',
      gap: 'Z',
      paddingTop: 'B',
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderTopColor: 'line',
      childExtends: 'ContentPageSectionLink',
      childrenAs: 'state',
      children: (el, s) => {
        const page = el.parent?.parent
        if (!page) return []
        const sections = page.sections
        return typeof sections === 'function' ? sections(el, s) : (sections || [])
      }
    }
  }
}

export const ContentPageSectionLink = {
  tag: 'button',
  border: 'none',
  fontSize: 'Z2',
  fontWeight: '600',
  padding: 'Z A',
  margin: '- -A',
  round: 'C',
  cursor: 'pointer',
  textAlign: 'left',
  background: (el, s) =>
    (s.root?.contentSection || null) === (s.label || null) ? 'overlay' : 'transparent',
  color: (el, s) =>
    (s.root?.contentSection || null) === (s.label || null) ? 'title' : 'caption',
  ':hover': { color: 'title', background: 'overlay' },
  text: (el, s) => s.label,
  onClick: (e, el, s) => {
    e.preventDefault()
    s.root.update({ contentSection: s.label })
    setTimeout(() => {
      try {
        const target = document.querySelector(
          `[data-content-section="${(s.label || '').replace(/"/g, '\\"')}"]`
        )
        if (!target) return
        let scroller = target.parentElement
        while (scroller) {
          const cs = getComputedStyle(scroller)
          if (
            (cs.overflowY === 'auto' || cs.overflowY === 'scroll') &&
            scroller.scrollHeight > scroller.clientHeight + 5
          ) break
          scroller = scroller.parentElement
        }
        if (scroller) {
          const offset = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top
          scroller.scrollTop = scroller.scrollTop + offset - 16
        } else {
          target.scrollIntoView({ block: 'start' })
        }
      } catch {}
    }, 0)
  }
}
